export default "__VITE_ASSET__CT1Vs8qc__"